// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../node_modules/css-loader/dist/cjs.js!./fonts/Inter/inter.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html,
body,
div,
p,
h1,
h2,
h3,
h4,
ul,
li,
span,
form,
input,
select,
button {
  margin: 0;
  padding: 0;
}
body {
  color: #333;
  background: #fff;
  font-family: Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
  font-size: 16px;
}
/*# sourceMappingURL=style.css.map */`, "",{"version":3,"sources":["webpack://./style.less","webpack://./src/style.less"],"names":[],"mappings":"AAEA;;;;;;;;;;;;;;;EAeE,SAAA;EACA,UAAA;ACAF;ADMA;EACE,WAAA;EACA,gBAAA;EACA,8GAAA;EASA,eAAA;ACZF;AACA,oCAAoC","sourcesContent":["@import \"./fonts/Inter/inter.css\";\n\nhtml,\nbody,\ndiv,\np,\nh1,\nh2,\nh3,\nh4,\nul,\nli,\nspan,\nform,\ninput,\nselect,\nbutton {\n  margin: 0;\n  padding: 0;\n}\n\n@text-main: #333;\n@fill-main: #fff;\n\nbody {\n  color: @text-main;\n  background: @fill-main;\n  font-family:\n    Inter,\n    -apple-system,\n    BlinkMacSystemFont,\n    \"Segoe UI\",\n    Roboto,\n    \"Helvetica Neue\",\n    Arial,\n    sans-serif;\n  font-size: 16px;\n}\n","@import \"fonts/Inter/inter.css\";\nhtml,\nbody,\ndiv,\np,\nh1,\nh2,\nh3,\nh4,\nul,\nli,\nspan,\nform,\ninput,\nselect,\nbutton {\n  margin: 0;\n  padding: 0;\n}\nbody {\n  color: #333;\n  background: #fff;\n  font-family: Inter, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, sans-serif;\n  font-size: 16px;\n}\n/*# sourceMappingURL=style.css.map */"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
